import AddItem from 'Shared/Invoices/Item/Invoice.AddItem'
import Item from 'Shared/Invoices/Item/Invoice.Item'

const TableBody = ({ children }) => <tbody>{children}</tbody>

TableBody.AddItem = AddItem
TableBody.Item = Item

export default TableBody
